import { httpInstance } from "@/plugins/http";
import { endpoints } from "./endpoints";

export async function resumeCameraSnapshots(cameraId) {
  const response = await httpInstance.post(endpoints.CAMERA_SNAPSHOT_RESUME, {
    camera_id: cameraId,
  });
  if (!response || response.status >= 300 || !response.data.success) {
    throw new Error("Could not change snapshot collection status");
  }
  return response.data;
}
